import { MetricsStatsDaily } from "../api/models";

export interface Props {
    metricsStats?: MetricsStatsDaily;
    excludeParkingRevenue?: boolean;
}

function MetricPill({ label, value }: { label: string; value: string }) {
    return (
        <div className="flex flex-col items-center gap-0.5 py-1.5 w-[72px]">
            <span className="text-base font-semibold text-text tabular-nums leading-tight">{value}</span>
            <span className="text-2xs text-text-3 uppercase tracking-wider font-medium whitespace-nowrap leading-tight">{label}</span>
        </div>
    );
}

const MetricsStats = (props: Props) => {
    if (!props.metricsStats || props.metricsStats.totalDomains <= 0) {
        return <div className="text-sm text-text-3 py-4 text-center">Unavailable</div>;
    }

    const m = props.metricsStats;
    const pct = (n: number) => ((n / m.totalDomains) * 100).toFixed(0) + '%';

    return (
        <div className="flex flex-wrap justify-evenly">
            <MetricPill label="Ahrefs DR" value={pct(m.ahrefsDr)} />
            <MetricPill label="Extensions" value={pct(m.extensionsTaken)} />
            <MetricPill label="GoScore" value={pct(m.goscore)} />
            <MetricPill label="Estibot" value={pct(m.estibot)} />
            <MetricPill label="Whois" value={pct(m.whoisCreate)} />
            {!props.excludeParkingRevenue && <MetricPill label="Parking" value={pct(m.parkingRevenue)} />}
        </div>
    );
};

export default MetricsStats;
